import { resolveComponent as _resolveComponent, createVNode as _createVNode, withMemo as _withMemo } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_descriptor = _resolveComponent("inline-descriptor")!

  return _withMemo([_ctx.computedModelValue, _ctx.computedSchema], () => _createVNode(_component_inline_descriptor, {
    ref: "inlineDescriptor",
    id: _ctx.id,
    editable: "",
    "model-value": _ctx.computedModelValue,
    schema: _ctx.computedSchema,
    "token-styles": _ctx.tokenStyles,
    separators: _ctx.separators,
    "update-token": _ctx.customUpdateToken,
    onChipAdded: _ctx.onChipAdded,
    onChipRemoved: _ctx.onChipRemoved,
    onChipSelected: _ctx.onChipSelected
  }, null, 8, ["id", "model-value", "schema", "token-styles", "separators", "update-token", "onChipAdded", "onChipRemoved", "onChipSelected"]), _cache, 0)
}